<template>
  <div :class="$style.base">
    <div :class="$style.content">
      {{$t('confirmation_message')}}
      <div :class="$style.buttons">
        <BaseButton 
          @click.native="$emit('close')" 
          light
        >
          {{$t('no')}}
        </BaseButton>
        <BaseButton 
          @click.native="$emit('submit')"
          v-test="'confirmation-yes'"
        >
          {{$t('yes')}}
        </BaseButton>
      </div>
    </div>
    <div 
      @click="$emit('close')"
      :class="$style.background" 
    />
  </div>
</template>

<script>
import BaseButton from '@/components/BaseButton'

export default {
  components: {
    BaseButton
  }
}
</script>

<style lang="scss" module>
.base {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.content {
  position: relative;
  z-index: 1;
  width: 350px;
  max-width: 100%;
  margin: 15% auto;
  padding: $spacing;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
}

.background {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: $spacing;

  & > * {
    margin-left: 10px;
  }
}
</style>
